<section class=" container-fluid missed-work-report">
    <form [formGroup]="studentReport">
        <div class="row my-2">
            <div class="form-group col-6 col-md-3 px-0" *ngIf="classShow && class_id == ''">
                <label class="col-xl-12 col-md-12 font-weight-bold">Class Name</label>
                <div class="col-xl-12 col-md-12">
                    <input type="text" placeholder="Class Name" readonly class="form-control"
                           [value]="reportData.class_name">
                </div>
            </div>
            <div class="form-group col-6 col-md-3 px-0" *ngIf="missedWorkStudentNoRecord">
                <label class="col-xl-12 col-md-12 font-weight-bold">Student List</label>
                <div class="col-xl-12 col-md-12">
                    <ng-select
                            [readonly]="student_id != ''"
                            (change)="studentReportDetails()"
                            [items]="studentList"
                            bindLabel="student_name"
                            bindValue="student_id"
                            formControlName="studentName"
                            placeholder="Student List">
                    </ng-select>
                </div>
            </div>
            <!--            <div class="form-group col-12 col-md-3" *ngIf="missedWorkStudentNoRecord == true">-->
            <!--                <label class="col-xl-12 col-md-12">Student</label>-->
            <!--                <select class="custom-select col-md-12" formControlName="studentName" (change)="studentReportDetails()">-->
            <!--                    <option value="">All</option>-->
            <!--                    <option *ngFor="let student of studentList" [value]="student.student_id">{{student.student_name}}</option>-->
            <!--                </select>-->
            <!--            </div>-->
            <div class="form-group col-6 col-md-{{classShow && showContent == 'other' && class_id == '' ? '2' : '3'}} pl-0"
                 *ngIf="classShow && showContent == 'other'">
                <label class="col-xl-12 col-md-12 px-0 font-weight-bold">Content Type</label>
                <select class="custom-select col-md-12" formControlName="contentType" (change)="contentTypeSelect()">
                    <option value="2">Assignment</option>
                    <option value="3">Assessment</option>
                </select>
            </div>
            <div class="form-group col-6 col-md-{{classShow && (showContent == 'Assignment' || showContent == 'Assessment') && class_id == '' ? '2' : '3'}} pl-0"
                 *ngIf="classShow && (showContent == 'Assignment' || showContent == 'Assessment')">
                <label class="col-xl-12 col-md-12 px-0 font-weight-bold">Content Type</label>
                <div class="col-xl-12 col-md-12">
                    <input type="text" placeholder="Class Name" readonly class="form-control" [value]="showContent">
                </div>
            </div>
            <div class="form-group col-6 col-md-{{class_id == '' ? '2' : '3'}} pl-0">
                <label class="col-xl-12 col-md-12 px-0 font-weight-bold">Status</label>
                <select class="custom-select col-md-12" formControlName="submitted" (change)="studentReportDetails()">
                    <option value="">All</option>
                    <option value="1">Up Coming</option>
                    <option value="2">In Progress</option>
                    <option value="3">Completed</option>
                    <option value="4">Overdue</option>
                    <option value="5">Not Started</option>
                </select>
            </div>

            <div class="form-group col-6 col-md-{{class_id == '' ? '2' : '3'}} pl-0" *ngIf="showContent != 'Resource'">
                <label class="col-xl-12 col-md-12 px-0 font-weight-bold">Performance</label>
                <select class="custom-select col-md-12" formControlName="performance" (change)="studentReportDetails()">
                    <option value="">All</option>
                    <option value="1">Master</option>
                    <option value="2">Excellent</option>
                    <option value="3">Proficient</option>
                    <option value="4">Average</option>
                    <option value="5">Below Average</option>
                    <option value="6">Missed</option>
                </select>
            </div>

            <div class="form-group col-6 col-md-3 px-0" *ngIf="timeView">
                <label class="col-xl-12 col-md-12 font-weight-bold">From Date</label>
                <div class="col-xl-12 col-md-12 form-group">
                    <div class="input-group">
                        <input class="form-control" name="fromdate" placeholder="mm/dd/yyyy" [options]="myDpOptions"
                               formControlName="fromDate" angular-mydatepicker #dp="angular-mydatepicker"
                               (dateChanged)="onDateChanged1($event, '1')">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary" style="padding: 6px 12px" (click)="dp.toggleCalendar()">
                                <i class="fa fa-calendar-o"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group col-6 col-md-3" style="padding: 0 14px 0 0 !important" *ngIf="timeView">
                <label class="col-xl-12 col-md-12 px-0 font-weight-bold">To Date</label>
                <div class="col-xl-12 col-md-12 form-group px-0">
                    <div class="input-group">
                        <input class="form-control" name="todate" placeholder="mm/dd/yyyy"
                               formControlName="toDate" angular-mydatepicker #dp1="angular-mydatepicker"
                               [options]="myDpOptions1" (dateChanged)="onDateChanged1($event, '2')"/>
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary" style="padding: 6px 12px" (click)="dp1.toggleCalendar()">
                                <i class="fa fa-calendar-o"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group col-6 col-md-6 px-0">
                <label class="col-xl-12 col-md-12 font-weight-bold px-0">Content Name</label>
                <div class="col-xl-12 col-md-12 px-0">
                    <ng-select #missedWorkContent (change)="selectContantName($event)"
                               [items]="studentContentList"
                               bindLabel="content_name"
                               bindValue="content_id"
                               formControlName="contentName"
                               placeholder="Content Name"
                               [multiple]="true"
                               [attr.title]="missedWorkContent.selectedValues | ngSelectTitle: missedWorkContent.bindLabel"
                               [readonly]="showContentDetails">
                        <ng-template ng-header-tmp>
                            <h5 class="cursor letter pt-2" (click)="onSelectAll()">Select All</h5>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice : 0 : 4">
                                <span class="ng-value-label">{{ item.content_name }}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 4">
                                <span class="ng-value-label font-weight-bold">{{ items.length - 4 }} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
        </div>
    </form>
    <!--    <div class="row" *ngIf="missedWorkNoRecord">-->
    <!--        <div class="col-md-6">-->
    <!--        </div>-->
    <!--        <div class="col-md-6">-->
    <!--            <h6 class="yet-to-start-color">Yet To Start</h6>-->
    <!--            <h6 class="in-progress-color">In Progress</h6>-->
    <!--            <h6 class="completed-color">Completed</h6>-->
    <!--            <h6 class="over-due">Overdue</h6>-->
    <!--            <h6 class="yet-to-start-color">In Progress - Not Started</h6>-->
    <!--        </div>-->
    <!--    </div>-->
    <div class="row" *ngIf="missedWorkNoRecord">
        <div class="col-12 report-card-wrap">
            <div class="report-card-header">
                <div class="report-heading">
                    <span class="report-icon"><i class="fa fa-clipboard" aria-hidden="true"></i></span>
                    <div>
                        <h3 class="mb-1">{{studentReport.controls.contentType.value == '2' ? 'Assignment' : 'Assessment'}} Details</h3>
                        <p class="mb-0">Overview of student performance across all assignments and contents.</p>
                    </div>
                </div>
                <div class="report-legend">
                    <span class="legend-pill"><i class="fa fa-square yet-to-start-color-bg"></i>Up-Coming</span>
                    <span class="legend-pill"><i class="fa fa-square in-progress-color-bg"></i>In Progress</span>
                    <span class="legend-pill"><i class="fa fa-square completed-color-bg"></i>Completed</span>
                    <span class="legend-pill"><i class="fa fa-square pending-color-bg"></i>Pending</span>
                    <span class="legend-pill"><i class="fa fa-square over-due-bg"></i>Overdue</span>
                    <span class="legend-pill"><i class="fa fa-square never-bg"></i>Not Started</span>
                </div>
            </div>
            <!--        <ng2-smart-table [settings]="missedWorkReport"  [source]="rows"></ng2-smart-table>-->
            <!--            <ngx-datatable-->
            <!--                    class="bootstrap"-->
            <!--                    [rows]="rows"-->
            <!--                    [columnMode]="'force'"-->
            <!--                    [headerHeight]="50"-->
            <!--                    [footerHeight]="50"-->
            <!--                    [rowHeight]="'auto'"-->
            <!--                    [externalPaging]="true"-->
            <!--                    [count]="totalrecords"-->
            <!--                    [offset]="pageOffSet"-->
            <!--                    [limit]="recordsperpage"-->
            <!--                    (page)='setPage($event)'-->
            <!--                    [scrollbarH]="harizontalScroll">-->

            <!--                <ngx-datatable-column name="Student Name" prop="student_name">-->
            <!--                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">-->
            <!--                        <h6>{{row.student_name}}</h6>-->
            <!--                    </ng-template>-->
            <!--                </ngx-datatable-column>-->
            <!--getRowIndex(rows-->
            <!--                <ngx-datatable-column *ngFor="let col1 of coloumValues[0]; let i = index" [name]="rows.content_name">-->
            <!--                    <ng-template *ngFor="let col of col1[i];" ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">-->
            <!--&lt;!&ndash;                        <p>&ndash;&gt;-->
            <!--                            <span class="yet-to-start-color" *ngIf="col.color == '1'"></span>-->
            <!--&lt;!&ndash;                        </p>&ndash;&gt;-->
            <!--                        <span class="in-progress-color" *ngIf="col.color == '2'"></span>-->
            <!--                        <span class="completed-color" *ngIf="col.color == '3'"></span>-->
            <!--                        <span class="over-due" *ngIf="col.color == '4'" (click)="notifyParent(col, 2)"> Notify Parent</span>-->
            <!--                        <span class="never" *ngIf="col.color == '5'"></span>-->
            <!--                    </ng-template>-->
            <!--                </ngx-datatable-column>-->

            <!--                <ngx-datatable-column name="Performance" prop="performance">-->
            <!--                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row" let-value="value">-->
            <!--                        <h6>{{value}}<span *ngIf="value != '-'">%</span></h6>-->
            <!--                    </ng-template>-->
            <!--                </ngx-datatable-column>-->
            <!--            </ngx-datatable>-->
            <div class="row">
                <div class="col-12 table-responsive-ipad table-shell">
                    <table class="table table-bordered report-table">
                        <thead *ngFor="let table of rows; let i=index;">
                        <th *ngIf="i==0;" class="student-col" style="vertical-align: middle; font-size: 13px">Student Name</th>
                        <ng-container *ngIf="i==0;">
                            <th *ngFor="let item of table.content" class="text-center align-middle content-head-col">
                                <span class="d-block content-title">{{item.content_name}}</span>
                                <span class="content-deadline" *ngIf="item.end_date != '0000-00-00'">{{item.end_date | customDateFormat}}</span>
                            </th>
                        </ng-container>
                        <th *ngIf="i == 0;" class="text-center align-middle performance-col">Performance</th>
                        </thead>
                        <tr *ngFor="let table of rows; let i=index;">
                            <td (click)="getStudentFullDetail(table)"
                                class="color-primary cursor student-name-cell">
                                <div class="student-chip">
                                    <span class="avatar-circle">{{getStudentInitials(table.student_name)}}</span>
                                    <span class="student-label">{{table.student_name}}</span>
                                </div>
                            </td>
                            <td *ngFor="let item of table.content" class="text-center metric-col">
                                <div *ngIf="item.status == '2' || item.status == '3' || item.status == '6' || item.status == '7'"
                                     class="score-ratio">
                                    <span>{{item.attend_questions}}</span>/<span>{{item.total_questions}}</span>
                                </div>
                                <a (click)="notifyParent(item, 2)" *ngIf="item.status == '4' || item.status == '6'"
                                   class="d-block cursor notify-parent mb-1">Notify Parent <span
                                        *ngIf="item.status == '6'">({{item.parents_notify_count}})</span></a>
                                <span (click)="notifyParent(item, 2)" *ngIf="item.status == '4'" class="over-due cursor">{{item.student_average_score}}</span>
                                <span class="cursor muted-placeholder" *ngIf="item.status == '0' || item.status == ''">-</span>
                                <span class="yet-to-start-color cursor score-pill" (click)="studentCorrectionDetail(item)"
                                      *ngIf="item.status == '1'">{{item.student_average_score}}</span>
                                <span (click)="studentCorrectionDetail(item)" *ngIf="item.status == '2' || item.status == '6'"
                                      class="in-progress-color cursor score-pill">{{item.student_average_score}}</span>
                                <span class="completed-color cursor score-pill" (click)="studentCorrectionDetail(item)"
                                      *ngIf="item.status == '3'">{{item.student_average_score}}</span>
                                <span class="never cursor score-pill" (click)="studentNotAnswer(item)"
                                      *ngIf="item.status == '5'">{{item.student_average_score}}</span>
                                <span (click)="studentCorrectionDetail(item)" *ngIf="item.status == '7'"
                                      class="pending-color cursor score-pill">{{item.student_average_score}}</span>
                                <span *ngIf="item.testcode_id > 0" class="ml-2 cursor bg-primary p-1 score-chart-chip"
                                      title="score Details" (click)="scoreRedirect(item.student_content_id)"><i
                                        class="fa fa-line-chart" aria-hidden="true"></i></span>
                            </td>
                            <td class="text-center align-middle performance-cell">{{table.performance}}<span
                                    *ngIf="table.performance != '-'">%</span></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="row d-flex justify-content-center list-card mt-3" *ngIf="!missedWorkNoRecord">
        <div class="col-12">
            <button class="nodataList">{{message}}</button>
        </div>
    </div>

    <ng-template #contentnow let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title"><b>Notify Parent</b></h4>
        </div>
        <div class="modal-body">
            <h5>Are you sure want to notify {{studentname[0].student_name}} parents ?</h5>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn cancel" (click)="close()">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="confirmNotifiy()">Confirm</button>
        </div>
    </ng-template>
</section>

<ng-template #notStarted let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title"><b>Not Started</b></h4>
    </div>
    <div class="modal-body">
        <h5> Not submitted the
            <span *ngIf="studentReport.controls.contentType.value  == '2'">Assignment</span>
            <span *ngIf="studentReport.controls.contentType.value  == '3'">Assessment</span> yet.</h5>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn cancel" (click)="closeNotstarted()">Ok</button>
    </div>
</ng-template>

<ng-template #viewStudentDetails let-c="close" let-d="dismiss">
    <div class="modal-header align-items-center">
        <h4 class="modal-title font-weight-bold">Student Answer Report - <span
                class="color-primary">{{contentData}}</span></h4>
        <i class="fa fa-close cursor" (click)="onSave()"></i>
    </div>
    <div class="modal-body">
        <div *ngIf="contentData == ''" id="custom-pdf-loader" style="height: 40vh;">
            <img alt="" src="assets/images/pre-loader/loader-01.svg">
        </div>
        <app-answer-sheet (studentName)="getStudentName($event)" [answerShow]="true"
                          [backStatus]="false" [classId]="classId" [contentFormat]="contentFormat"
                          [contentId]="contentId" [studentReportId]="studentId" [is_test]="is_test"
                          [studentContentId]="studentContentId"></app-answer-sheet>
    </div>
</ng-template>

<ng-template #viewoveralldetails let-c="close" let-d="dismiss">
    <div class="modal-header align-items-center">
        <h4 class="modal-title color-primary font-weight-bold" id="modal-basic-title">{{studentName}} Overall
            details</h4>
        <i (click)="closeOverAll()" aria-hidden="true"
           class="fa fa-close fa-lg mt-1" style="color:#7F3486; cursor: pointer; float: right;"></i>
    </div>
    <div class="modal-body">
        <app-overalldetails
                [studentdata]="viewdetail"
        >
        </app-overalldetails>
    </div>
</ng-template>
